import React from "react";
import Prediksi from "../components/Prediksi";


const Prediksipage = () => {
    return (
        <>
            <div className="font-primary">
                <Prediksi/>
            </div>            
        </>
    );
};

export default Prediksipage